__turbopack_context__.v({
  "backdrop": "CartDrawer-module__N7guaG__backdrop",
  "body": "CartDrawer-module__N7guaG__body",
  "checkout": "CartDrawer-module__N7guaG__checkout",
  "close": "CartDrawer-module__N7guaG__close",
  "details": "CartDrawer-module__N7guaG__details",
  "disclosure": "CartDrawer-module__N7guaG__disclosure",
  "empty": "CartDrawer-module__N7guaG__empty",
  "eyebrow": "CartDrawer-module__N7guaG__eyebrow",
  "fade": "CartDrawer-module__N7guaG__fade",
  "footer": "CartDrawer-module__N7guaG__footer",
  "header": "CartDrawer-module__N7guaG__header",
  "item": "CartDrawer-module__N7guaG__item",
  "itemMeta": "CartDrawer-module__N7guaG__itemMeta",
  "itemTitle": "CartDrawer-module__N7guaG__itemTitle",
  "itemTotal": "CartDrawer-module__N7guaG__itemTotal",
  "list": "CartDrawer-module__N7guaG__list",
  "panel": "CartDrawer-module__N7guaG__panel",
  "remove": "CartDrawer-module__N7guaG__remove",
  "slide": "CartDrawer-module__N7guaG__slide",
  "status": "CartDrawer-module__N7guaG__status",
  "subtotal": "CartDrawer-module__N7guaG__subtotal",
  "subtotalAmount": "CartDrawer-module__N7guaG__subtotalAmount",
  "title": "CartDrawer-module__N7guaG__title",
});
